import  types  from "../types/types";
import { CategoriaLineaConvocatoria } from "../../models/ConvocatoriasModel/convocatoria.model";

export const id_Participante = (idParticipante: number) => ({
  type: types.idParticipante,
  payload: {
    idParticipante,
  },
});

export const categoriasLineasConvocatoria = (categoria_linea_convocatoria: CategoriaLineaConvocatoria[] ) => ({
  type: types.categoria_linea_convocatoria,
  payload: {
    categoria_linea_convocatoria,
  },
});

export const nombreConvocatoria = (nombre_convocatoria: string) => ({
  type: types.nombre_convocatoria,
  payload: {
    nombre_convocatoria,
  },
});

export const idConvocatoriaSelecionada = (idconvocatorias: number) => ({
  type: types.id_convocatoria_seleccionada,
  payload: {
    idconvocatorias,
  },
});

export const idPostulacion = (id_postulacion: number) => ({
  type: types.id_postulacion,
  payload: {
    id_postulacion,
  },
});

export const tipoParticipante = (tipo_participante: any) => ({
  type: types.tipo_participante,
  payload: {
    tipo_participante,
  },
});


export const guardarDatosPostulacion = (datos_postulacion: any) => ({
  type: types.datos_postulacion,
  payload: {
    datos_postulacion,
  },
});